import type { jsPDF } from "jspdf";

const NEQAS_LOGO_SRC = "/NEQAS_LOGO.jpeg";
const LOGO_ASPECT = 1026 / 430;

export const isVerifiedByNeqas = (value: unknown): boolean =>
  value === true ||
  value === "Yes" ||
  value === "yes" ||
  value === 1 ||
  value === "true";

export const loadNeqasLogo = (): Promise<string | null> =>
  new Promise((resolve) => {
    const img = new Image();
    img.onload = () => {
      try {
        const canvas = document.createElement("canvas");
        canvas.width = img.naturalWidth;
        canvas.height = img.naturalHeight;
        const ctx = canvas.getContext("2d");
        if (!ctx || !img.naturalWidth) {
          resolve(null);
          return;
        }
        ctx.drawImage(img, 0, 0);
        resolve(canvas.toDataURL("image/jpeg", 0.92));
      } catch {
        resolve(null);
      }
    };
    img.onerror = () => resolve(null);
    img.src = NEQAS_LOGO_SRC;
  });

export const fetchVerifiedByNeqas = async (
  fallback?: unknown
): Promise<boolean> => {
  try {
    const token = localStorage.getItem("token");
    const response = await fetch(
      `${process.env.REACT_APP_ADMIN_API_URL}/projects/getProjectProfile`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    if (!response.ok) return isVerifiedByNeqas(fallback);
    const json = await response.json();
    return isVerifiedByNeqas(json?.data?.verifiedByNeqas);
  } catch {
    return isVerifiedByNeqas(fallback);
  }
};

export const drawNeqasLogoBesideVerification = (
  doc: jsPDF,
  logoDataUrl: string,
  pageWidth: number,
  footerStartY: number
) => {
  const logoHeight = 38;
  const logoWidth = logoHeight * LOGO_ASPECT;
  const rightMargin = 20;
  const logoX = pageWidth - rightMargin - logoWidth;
  const logoY = footerStartY + 3 - logoHeight;
  doc.addImage(logoDataUrl, "JPEG", logoX, logoY, logoWidth, logoHeight, "NEQAS_LOGO");
};
